import { AdminPanelName, AdminPanelsState, HistoryStack } from '../../state';
import { ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX } from '../../actions';
import { combineReducers } from 'redux';
import { createHistoryStackReducer } from '../history-stack';

/**
 * Initial history stack state that has an empty entries array.
 */
const initialState: HistoryStack<AdminPanelName> = {
  entries: [{ name: AdminPanelName.Home, key: '' }],
  index: 0,
  lastAction: null,
};

export const adminPanelsReducer = combineReducers<AdminPanelsState>({
  history: createHistoryStackReducer(
    ADMIN_PANELS_HISTORY_ACTION_TYPE_PREFIX,
    initialState,
  ),
});
